import React from 'react';
import { useParams } from 'react-router-dom';
import { PensioenbijPage, CONNECTION_PENSIOENBIJ_COLUMNS } from '../../../../Dashboard/Pages/Pensioenbij';
export const PensioenbijTab = () => {
  const { connectionId } = useParams<{ connectionId: string }>();
  return (
    <PensioenbijPage hideEmployerFilter connectionId={connectionId} tableColumns={CONNECTION_PENSIOENBIJ_COLUMNS} />
  );
};
